const ROOT = ['customers'] as const;

export const customersKeys = {
  root: ROOT,
  search: (request: unknown) => [...ROOT, 'search', request] as const,
  summary: (customerId: string) => [...ROOT, 'summary', customerId] as const,
  contacts: (customerId: string) => [...ROOT, 'contacts', customerId] as const,
  addresses: (customerId: string) => [...ROOT, 'addresses', customerId] as const,
  recipients: (customerId: string) => [...ROOT, 'recipients', customerId] as const,
  consents: (customerId: string) => [...ROOT, 'consents', customerId] as const,
  accounts: (customerId: string) => [...ROOT, 'accounts', customerId] as const,
};
